import i18n from 'i18next';
import type { TFunction, TOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { ITranslations } from './interfaces/config';
import { translateI18nMessage, type I18nMessageWithParams } from './utils/translateI18nMessage';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'de',
    interpolation: {
      escapeValue: false,
    },
  });

const tOriginal: TFunction = i18n.t.bind(i18n);
// Tuple form ['key', ...args] -> translate key, then %s/%% on the result.
// (Arrays of 2+ string keys for i18next fallback, t(['a','b']), are not used here; use t('a') or a single key.)
i18n.t = function tWithSprintf(keyOr: unknown, ...rest: unknown[]) {
  if (Array.isArray(keyOr) && keyOr.length >= 2 && typeof keyOr[0] === 'string') {
    if (rest.length === 0) {
      return translateI18nMessage(tOriginal, keyOr as I18nMessageWithParams);
    }
    if (rest.length === 1) {
      return translateI18nMessage(tOriginal, keyOr as I18nMessageWithParams, rest[0] as TOptions);
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (tOriginal as any)(keyOr, ...rest);
} as TFunction;

export const applyTranslations = (translations: ITranslations, defaultLng: string) => {
  console.log('[i18n] applyTranslations called with:', { translations, defaultLng });
  const adminToolTranslations = translations['fishven-admin-tool'];
  console.log('[i18n] adminToolTranslations found:', !!adminToolTranslations);

  if (adminToolTranslations) {
    const urlParams = new URLSearchParams(window.location.search);
    const displayKeysOnly = urlParams.has('displayKeysOnly');

    if (displayKeysOnly) {
      console.log('[i18n] displayKeysOnly is true, skipping translation application');
      return;
    }

    // Add resources for each language using addResourceBundle
    // This properly adds resources to an already-initialized i18n instance
    const languages = ['en', 'de', 'fr', 'it'] as const;
    languages.forEach((lang) => {
      if (adminToolTranslations[lang]) {
        i18n.addResourceBundle(lang, 'translation', adminToolTranslations[lang], true, true);
        console.log(`[i18n] Added ${lang} translations`);
      }
    });

    // Change language if needed
    if (defaultLng && i18n.language !== defaultLng) {
      console.log('[i18n] Changing language from', i18n.language, 'to', defaultLng);
      void i18n.changeLanguage(defaultLng);
    }

    console.log('[i18n] Translations applied successfully');
  } else {
    console.warn('[i18n] No fishven-admin-tool translations found in:', Object.keys(translations));
  }
};

export default i18n;
